import type { QueryClient } from '@tanstack/react-query'

// Query-key prefixes that aren't auto-invalidated by Refine's useCreate /
// useUpdate / useDelete. Owners:
//   ['dashboard']           — src/pages/dashboard/hooks/*
//   ['usersByIds']          — src/hooks/useUsersByIds.ts
//   ['vmsByIds']            — src/hooks/useVmsByIds.ts
//   ['roles', 'all']        — src/pages/roles/hooks/useRoles.ts
//   ['roles', 'detail']     — src/pages/roles/hooks/useRoleDetail.ts
//   ['roles', 'scopes']     — src/pages/roles/hooks/usePermissionScopes.ts
//   ['data', 'default']     — useCustom queries (Refine keys them outside
//                             the resource graph, so useInvalidate on a
//                             resource doesn't touch them)
//
// Invalidation here is unscoped by design: `invalidateQueries` only marks
// entries stale, no network is issued until an active observer refetches,
// so over-invalidating is cheap and avoids having to thread a per-mutation
// scope through every call site.
const ADMIN_CACHE_PREFIXES: readonly (readonly string[])[] = [
  ['dashboard'],
  ['usersByIds'],
  ['vmsByIds'],
  ['data', 'default'],
  ['roles', 'all'],
  ['roles', 'detail'],
  ['roles', 'scopes'],
]

export function invalidateAdminCaches(queryClient: QueryClient): void {
  for (const queryKey of ADMIN_CACHE_PREFIXES) {
    void queryClient.invalidateQueries({ queryKey })
  }
}
